import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Link, NavLink, useHistory } from "react-router-dom";
import Storage from "../../utils/storage";
import Logo from "../../assets/assets/Nibss-Logo.png";
import HomeIcon from "../../assets/assets/home.svg";
import HistoryLogo from "../../assets/assets/history.svg";
import LogOutIcon from "../../assets/assets/shutdown.svg";
import { mapDispatchToProps } from "./mapDispatchToProps";

const NipSidebar2 = ({ isLoggingOut, logOut }) => {
  let userToken = Storage.get("user-access-token");
  const history = useHistory();

  const logout = () => {
    const payload = {
      access_token: userToken,
    };
    logOut(payload, history);
  };
  return (
    <div className="sidebar2">
      <div className="sidebar2-logo">
        <input type="checkbox" id="nav-check" />
        <div className="sidebar2-left">
          <label htmlFor="nav-check">
            <div className="close"></div>
          </label>
        </div>
        <Link to="/dashboard">
          <div className="sidebar2-logo-section">
            <img src={Logo} alt="logo" />
          </div>
        </Link>
      </div>
      <div className="side-links">
        <NavLink to="/nip/home" activeClassName="nip-green">
          <div className="sidebar2-item">
            <div className="sidebar2-item-icon">
              <img src={HomeIcon} alt="home-icon" />
            </div>
            <span>Home</span>
          </div>
        </NavLink>
        <NavLink to="/nip/history" activeClassName="nip-green">
          <div className="sidebar2-item">
            <div className="sidebar2-item-icon">
              <img src={HistoryLogo} alt="add-icon" />
            </div>
            <span>API History</span>
          </div>
        </NavLink>
      </div>
      <br />
      <br />
      <br />
      <div className="sideline-break"></div>
      <br />
      <div className="sidebar2-item" onClick={logout} data-testid="logout">
        <div className="sidebar2-item-icon">
          <img src={LogOutIcon} alt="logout-icon" />
        </div>
        <span>{isLoggingOut ? "Logging Out..." : "Log Out"}</span>
      </div>
    </div>
  );
};

NipSidebar2.propTypes = {
  isLoggingOut: PropTypes.any,
  logOut: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    isLoggingOut: state.auth.isLoggingOut,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NipSidebar2);
